(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initAccordion(root) {
      if (root.dataset.csfInit === '1') return;
      root.dataset.csfInit = '1';

      var singleOpen = root.getAttribute('data-csf-single-open') === 'true';
      var toggles = root.querySelectorAll('[data-csf-toggle]');

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;

          if (singleOpen && !expanded) {
            toggles.forEach(function (other) {
              if (other === btn) return;
              if (other.getAttribute('aria-expanded') === 'true') {
                closePanel(other);
              }
            });
          }

          if (expanded) {
            closePanel(btn);
          } else {
            openPanel(btn, panel);
          }
        });
      });
    }

    function openPanel(btn, panel) {
      panel.hidden = false;
      void panel.offsetHeight;
      panel.setAttribute('data-csf-open', 'true');
      btn.setAttribute('aria-expanded', 'true');
    }

    function closePanel(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('data-csf-open');
      if (reduceMotion) {
        panel.hidden = true;
        return;
      }
      var onEnd = function (e) {
        if (e.propertyName !== 'grid-template-rows') return;
        panel.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    }

    function initReveal(root) {
      var targets = root.querySelectorAll('[data-csf-reveal]');
      if (!targets.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('csf-is-visible'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('csf-is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      targets.forEach(function (el, i) {
        el.style.transitionDelay = Math.min(i * 35, 320) + 'ms';
        io.observe(el);
      });
    }

    function boot() {
      document.querySelectorAll('[data-csf-root]').forEach(function (root) {
        initAccordion(root);
        initReveal(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-csf-root]');
      if (root) {
        initAccordion(root);
        initReveal(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm_learn_body"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function () {
    var roots = document.querySelectorAll('.pm-learn-body');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.pmInit === '1') { return; }
      root.dataset.pmInit = '1';

      var bar = root.querySelector('[data-pm-bar]');
      if (bar) {
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
          bar.style.width = Math.min(100, Math.max(0, pct)).toFixed(2) + '%';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      var links = root.querySelectorAll('[data-pm-goto]');
      if (!links.length) { return; }

      Array.prototype.forEach.call(links, function (a) {
        a.addEventListener('click', function (e) {
          var target = document.getElementById(a.getAttribute('data-pm-goto'));
          if (!target) { return; }
          e.preventDefault();
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });

      if (!('IntersectionObserver' in window)) { return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) { return; }
          Array.prototype.forEach.call(links, function (a) {
            a.classList.toggle('is-active', a.getAttribute('data-pm-goto') === entry.target.id);
          });
        });
      }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });

      Array.prototype.forEach.call(links, function (a) {
        var target = document.getElementById(a.getAttribute('data-pm-goto'));
        if (target) { io.observe(target); }
      });
    });
  };
  init();
  // re-run when the theme editor re-renders this section
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
